export default __webpack_public_path__ + "static/media/noDoneRegstr.fae70773.svg";